// import React from 'react'
// import { Outlet } from 'react-router'
// import Header from '../header/header'
// import SideBar from '../sidebar/sideBar'

// interface Props { }

// function DashboardLayout(props: Props) {
//     const { } = props

//     return (
//        <>
            

//             <div className="flex bg-[#F7F7FB] h-screen w-full overflow-x-hidden">
//                 <SideBar />

//                 <main className="flex-1 min-w-0 min-h-screen h-full lg:border-l-8 border-black overflow-hidden">
//                     <div className="rounded-t-[8px] h-full flex flex-col">
//                         <div className="flex-1 overflow-auto w-full bw-scroll">
//                             <Outlet />
//                         </div>
//                     </div>
//                 </main>
//             </div>
       
//         </>
//     )
// }

// export default DashboardLayout
import React from 'react'
import { Outlet } from 'react-router'
import Navbar from '../sidebar/sideBar' // update import path to your new Navbar file

interface Props { }

function DashboardLayout(props: Props) {
    const { } = props

    return (
        <div className="min-h-screen h-screen flex flex-col bg-[#F7F7FB]">
            
            {/* Top header — sticky, in normal flow, desktop only (mobile renders bottom nav) */}
            <Navbar />

            {/* Main content area — fills remaining height below header */}
            <main className="flex-1 min-w-0  flex flex-col">
                <div className="flex-1 overflow-auto w-full bw-scroll pb-16 sm:pb-0">
                    {/* pb-16 clears the mobile fixed bottom nav (62px) */}
                    <Outlet />
                </div>
            </main>

        </div>
    )
}

export default DashboardLayout